export const GET_LOCATION = 'GET_LOCATION';
export const MAP_SEARCH = 'MAP_SEARCH';
export const PLACE_AUTOCOMPLETE = 'PLACE_AUTOCOMPLETE';
export const SET_ACTIVE_FILTER_TAB = 'SET_ACTIVE_FILTER_TAB';
